var _g, _g2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardFillSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.024 22c1.253 0 2.328-.066 3.227-.265.91-.203 1.698-.555 2.314-1.17.615-.616.967-1.404 1.17-2.314.2-.899.265-1.974.265-3.227V12a2 2 0 0 0-2-2h-8a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2zM2 15.024c0 1.253.066 2.328.266 3.227.202.91.554 1.698 1.17 2.314.615.615 1.403.967 2.313 1.17q.13.028.263.054C7.096 21.999 8 21.081 8 19.976V12a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2zM8.976 2c-1.253 0-2.328.066-3.227.266-.91.202-1.698.554-2.314 1.17-.615.615-.967 1.403-1.17 2.313q-.025.113-.046.225C2.004 7.073 2.939 8 4.059 8h15.917c1.105 0 2.023-.904 1.813-1.988l-.055-.263c-.202-.91-.554-1.698-1.17-2.314-.615-.615-1.403-.967-2.313-1.17-.899-.2-1.974-.265-3.227-.265z",
    fill: "#304ffe"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFillSvgrepoCom);
export default __webpack_public_path__ + "static/media/dashboard-fill-svgrepo-com.6bfecf03e55dea31a3a04d0d4d59d033.svg";
export { ForwardRef as ReactComponent };